<app-helpers-labels-edit-diff-box
  [labels]="project.labels"
  [allowClose]="true"
  [minLabels]="1"
  (labelsChange)="setLabels($event)"
  (close)="close.emit($event)"
></app-helpers-labels-edit-diff-box>